export interface RumorBlock {
  type: "p" | "h2" | "quote";
  text: string;
}

export interface Rumor {
  id: string;
  title: string;
  categorySlug: string;
  categoryName: string;
  excerpt: string;
  cover: string;
  insider: string;
  publishedAt: string;
  heat: number;
  tags: string[];
  blocks: RumorBlock[];
}

export const rumors: Rumor[] = [
  {
    id: "variety-show-cast-swap",
    title: "某顶流综艺录制前48小时临时换角，知情人还原那场深夜会议",
    categorySlug: "yule",
    categoryName: "娱乐圈",
    excerpt:
      "节目官方账号在开录前一天突然清空了三条预热物料。一位参与筹备的工作人员称，真正拍板的时刻，是凌晨一点半那场只有六个人在场的会议。",
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20television%20studio%20stage%20with%20empty%20director%20chairs%20and%20dramatic%20crimson%20spotlight%2C%20moody%20editorial%20photography%20with%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20cinematic%20atmosphere&width=1200&height=800&seq=rumor-cover-variety-01&orientation=landscape",
    insider: "前节目组统筹 · 代号「场记板」",
    publishedAt: "2026-09-08 23:40",
    heat: 98600,
    tags: ["综艺录制", "临时换角", "深夜会议"],
    blocks: [
      { type: "p", text: "预热物料的下架并不稀奇，稀奇的是时间点。按原计划，这档节目应在次日中午十二点发布官宣海报，可在此之前的十四个小时里，三条已经排期好的预告被逐条撤下，后台只剩下空白占位。" },
      { type: "p", text: "一位负责现场统筹的工作人员回忆，他是在收工后被拉进一个临时群的。群里只有六个人：总导演、制片人、两位平台内容负责人，以及两位统筹。会议持续了四十分钟，没有会议纪要，也没有留下任何一条结论性的聊天记录。" },
      { type: "h2", text: "被压到最后一刻的替代方案" },
      { type: "p", text: "换角并不是没有备选。筹备期其实一直有两套名单，A方案是已经拍摄了宣传片的阵容，B方案则是一份「随时可以启动」的替补名单，后者的合同条款里写明了极短的到岗时限，代价是费用要上浮三成左右。" },
      { type: "quote", text: "真正难的不是换谁，而是换完之后，前面拍的那些素材怎么办。宣发口径、赞助商露出、已经卖出去的联合冠名，全部要重新对一遍。" },
      { type: "p", text: "会上的分歧集中在一件事上：是硬着头皮按原阵容录，还是承受一次口碑上的剧烈波动。支持后者的一方给出的理由很直接——成片效果一旦拉胯，后续招商会更难看，而现在止损，至少还能保住一部分商业信任。" },
      { type: "p", text: "凌晨一点半，替代方案被启动。第二天上午，替补嘉宾的车队比预定时间提前两个小时抵达了录制基地。" },
    ],
  },
  {
    id: "tea-brand-franchise-price",
    title: "独家：某连锁茶饮加盟费突然腰斩，知情人还原那场谈判现场",
    categorySlug: "caijing",
    categoryName: "商业财经",
    excerpt:
      "一份本季度的内部政策文件显示，核心城市加盟门槛下调近一半。多位区域加盟商表示，消息来得比总部对外的公告早了整整九天。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20modern%20tea%20shop%20counter%20at%20dusk%20with%20warm%20golden%20lighting%20and%20blurred%20city%20window%20reflections%2C%20editorial%20business%20photography%2C%20rich%20amber%20tones%20with%20deep%20shadows&width=1200&height=800&seq=rumor-cover-tea-01&orientation=landscape",
    insider: "华东区域前招商负责人 · 代号「账本」",
    publishedAt: "2026-09-07 18:12",
    heat: 74200,
    tags: ["加盟政策", "招商", "内部文件"],
    blocks: [
      { type: "p", text: "变化最先出现在合同模板上。几位加盟商几乎同时发现，新一版的签约文件里，原本写死在附件的费用结构被替换成了一页「可调区间表」。这意味着议价空间第一次被正式写进了合同。" },
      { type: "h2", text: "九天的时间差" },
      { type: "p", text: "总部对外公告是在消息传开的第九天发布的。而在那之前，政策已经通过区域渠道层层下发了。一位前招商负责人说，这种「先落地、后公告」的做法在连锁行业并不罕见，目的是给区域留出缓冲，避免公告当天加盟商集体上门。" },
      { type: "p", text: "真正促成这次调整的，是连续三个季度的新店存活率数据。核心商圈的租金没有降，但客流恢复的速度不及预期，原本靠品牌溢价撑起来的高门槛开始变成招商阻力。" },
      { type: "quote", text: "门槛降下去容易，收回来难。这次讨论最激烈的一点是，要不要保留一条随时能回调的条款。" },
      { type: "p", text: "据称，会议最终采用了折中方案：书面门槛下调，但附加了与选址评估挂钩的动态系数。也就是说，能不能拿到最低价，取决于门店位置本身够不够好。" },
    ],
  },
  {
    id: "big-tech-reorg-sketch",
    title: "某大厂组织调整细节流出：一份没来得及收走的架构草图",
    categorySlug: "hulianwang",
    categoryName: "互联网",
    excerpt:
      "草图是在一场跨部门对齐会结束后被拍下的。上面用不同颜色的笔标记了三层汇报线，其中一处被反复涂改，最后用红笔圈了起来。",
    cover:
      "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20glass%20meeting%20room%20table%20with%20scattered%20printed%20org%20charts%20and%20a%20red%20marker%2C%20cool%20neutral%20lighting%20with%20a%20single%20warm%20desk%20lamp%2C%20editorial%20documentary%20photography&width=1200&height=800&seq=rumor-cover-tech-01&orientation=landscape",
    insider: "前中台产品经理 · 代号「日志」",
    publishedAt: "2026-09-06 21:05",
    heat: 68900,
    tags: ["组织架构", "中台", "汇报线"],
    blocks: [
      { type: "p", text: "在公司内部，架构调整通常以「业务优化」四个字收尾，但过程往往写在无数张打印纸上。这次流出的草图并不完整，只有三层节点，却已经足够看出方向。" },
      { type: "p", text: "被红笔圈起来的那一处，原本是两条独立汇报线共用的一个中间层。涂改的痕迹说明，讨论中存在过至少三种归属方案，最后落地的版本恰恰是最激进的那一种——中间层被直接取消。" },
      { type: "h2", text: "为什么是现在" },
      { type: "p", text: "时间点的选择往往比调整内容本身更值得琢磨。据了解，公司刚完成一轮年度预算核定，这意味着人事动作在财务口径上「有据可依」，不至于引发额外的资源争议。" },
      { type: "quote", text: "架构图从来不是原因，它是结果。真正的推动力是过去半年里几个核心指标的持续走平。" },
      { type: "p", text: "对于一线员工而言，最直接的感受可能不是架构，而是汇报流程变短了，以及原本并行的两套考核标准正在被合并。" },
    ],
  },
  {
    id: "period-drama-delay",
    title: "某S级古装剧撤档内幕：一次被提前三次的改档博弈",
    categorySlug: "zongyi",
    categoryName: "综艺影视",
    excerpt:
      "原定上线的档期在两周内被改了三次。参与后期的一位工作人员说，最后一次改动发生在开播前夜，理由只有一封不到两百字的邮件。",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20palace%20corridor%20at%20blue%20hour%20with%20warm%20lantern%20glow%20and%20long%20shadows%2C%20cinematic%20editorial%20photography%2C%20deep%20red%20lacquer%20details%20against%20dark%20stone&width=1200&height=800&seq=rumor-cover-drama-01&orientation=landscape",
    insider: "后期制作外包团队 · 代号「调色师」",
    publishedAt: "2026-09-05 20:30",
    heat: 81300,
    tags: ["剧集档期", "后期", "撤档"],
    blocks: [
      { type: "p", text: "改档在影视行业并不罕见，但短时间内连续三次改动，通常意味着背后有不止一方在施加压力。这次的情况恰是如此。" },
      { type: "p", text: "第一次改动来自平台排播，第二次与同档期另一部剧的宣发节奏撞车，而第三次，据称与一份尚未完成的审查补充材料有关。三次改动的理由彼此独立，却叠加成了同一个结果。" },
      { type: "h2", text: "那封两百字的邮件" },
      { type: "p", text: "后期团队是在开播前夜收到通知的。邮件很简短，只说了三件事：上线时间调整、物料发布暂停、后续安排另行通知。没有解释，也没有给出新的确切日期。" },
      { type: "quote", text: "对我们来说，最难受的不是改档，是改完之后不知道要做哪个版本。加急和精修，是两套完全不同的工序。" },
      { type: "p", text: "截至发稿，该剧的官方账号仍停留在最后一条倒计时海报上，评论区里观众的追问已经堆了上万条。" },
    ],
  },
  {
    id: "year-end-bonus-leak",
    title: "某上市公司年终奖方案提前泄露，员工群在凌晨两点炸开了",
    categorySlug: "zhichang",
    categoryName: "职场爆料",
    excerpt:
      "一张没有抬头的表格在几个部门之间流转。表格里没有具体金额，只有系数区间，但光是区间上限的调整，就足以让讨论持续一整夜。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20modern%20office%20at%20night%20with%20warm%20desk%20lamps%20glowing%20and%20a%20laptop%20screen%20showing%20a%20spreadsheet%2C%20moody%20editorial%20photography%20with%20amber%20highlights%20and%20dark%20surroundings&width=1200&height=800&seq=rumor-cover-office-01&orientation=landscape",
    insider: "某事业部HRBP · 代号「考勤卡」",
    publishedAt: "2026-09-04 02:14",
    heat: 92400,
    tags: ["年终奖", "绩效系数", "薪酬"],
    blocks: [
      { type: "p", text: "泄露的源头大概率是一次内部培训。为了让管理者理解新方案，HR准备了一份讲解版表格，而讲解版里保留了不同绩效档位的系数区间。" },
      { type: "p", text: "争议最大的并不是系数本身，而是区间跨度被拉大了。此前最高档与最低档之间的差距相对温和，新方案的上下限拉得更开，这意味着团队内部的分化会更明显。" },
      { type: "h2", text: "为什么凌晨两点才炸" },
      { type: "p", text: "表格是在白天开始流转的，但真正引发讨论的是深夜。原因很简单——部门负责人在晚饭后陆续给出了口头解释，而不同部门的解释口径并不完全一致。" },
      { type: "quote", text: "同一份方案，三个部门三种说法，员工当然会慌。信息不对称才是深夜刷屏的真正原因。" },
      { type: "p", text: "截至目前，公司尚未发布正式的书面说明，多位员工表示仍在等待一次全员沟通会。" },
    ],
  },
  {
    id: "idol-group-dissolve",
    title: "某组合解散传闻背后：合约到期前三个月，那场没人承认的谈判",
    categorySlug: "yule",
    categoryName: "娱乐圈",
    excerpt:
      "成员的个人工作室陆续注册，粉丝发现营业频率出现明显变化。多个信源指向同一次谈判，而那次谈判的知情人，至今不愿具名。",
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20corridor%20with%20empty%20wardrobe%20racks%20and%20warm%20vanity%20mirror%20lights%2C%20nostalgic%20editorial%20photography%20with%20soft%20golden%20haze%20and%20deep%20shadows&width=1200&height=800&seq=rumor-cover-idol-01&orientation=landscape",
    insider: "前经纪公司宣发 · 代号「应援棒」",
    publishedAt: "2026-09-03 19:48",
    heat: 105600,
    tags: ["合约到期", "组合", "个人工作室"],
    blocks: [
      { type: "p", text: "传闻的起点其实很细碎：某成员的两条动态间隔了三十一天，某场商演的海报里少了一个名字，某次直播中有人顺口说了句「以后」。" },
      { type: "p", text: "真正让讨论升级的，是几家公司主体的注册信息。虽然注册本身不能说明任何决定，但时间点集中在同一周，很难被当作巧合。" },
      { type: "h2", text: "谈判桌上的三个议题" },
      { type: "p", text: "据接近谈判的人士称，讨论基本围绕团体活动与个人发展的资源分配、既有商务合约的切割方式，以及剩余档期的履行安排展开。" },
      { type: "quote", text: "最难谈的从来不是分成比例，而是那些已经签了但还没执行的合约，谁去履行，谁去承担违约风险。" },
      { type: "p", text: "截至发稿，相关公司未就传闻作出回应，组合的官方账号仍在按既定节奏发布巡演物料。" },
    ],
  },
  {
    id: "ev-company-executive-wave",
    title: "某新能源车企高管密集离职，知情人称与一份对赌协议有关",
    categorySlug: "caijing",
    categoryName: "商业财经",
    excerpt:
      "两个月内，四个核心岗位先后换人。内部人士的说法是，人事动作本身就是对赌条款触发后的连锁反应。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20electric%20car%20production%20line%20at%20night%20with%20warm%20amber%20robotic%20arm%20lights%20and%20deep%20industrial%20shadows%2C%20clean%20editorial%20industrial%20photography&width=1200&height=800&seq=rumor-cover-ev-01&orientation=landscape",
    insider: "前供应链总监助理 · 代号「产线」",
    publishedAt: "2026-09-02 17:22",
    heat: 61800,
    tags: ["高管变动", "对赌", "供应链"],
    blocks: [
      { type: "p", text: "四个岗位分别是供应链、研发、市场和海外业务。在正常情况下，这四个方向的调整不会集中在同一季度完成。" },
      { type: "p", text: "一位接近管理层的人士表示，真正的触发点是半年度经营数据与承诺目标之间的差距。对赌条款一旦被触发，管理层往往需要以组织调整来给出回应。" },
      { type: "h2", text: "被低估的供应链变量" },
      { type: "p", text: "在新能源行业，供应链的稳定性直接决定交付节奏。有员工提到，过去半年里部分关键零部件的备选方案推进得比预期慢，这可能是压力传导的起点之一。" },
      { type: "quote", text: "对赌不是一次性事件，它会以季度为单位反复出现，每一次都会带来一轮调整。" },
      { type: "p", text: "公司方面对外表示人事变动属于正常轮岗，未就具体协议内容作出说明。" },
    ],
  },
  {
    id: "platform-algorithm-shift",
    title: "某平台流量规则突变内幕：一份改了七版的分配说明",
    categorySlug: "hulianwang",
    categoryName: "互联网",
    excerpt:
      "创作者的体感来得比官方说明更早。有人发现自己的完播率没变，播放量却掉了大半——问题出在规则的第七次修改上。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20wall%20with%20warm%20amber%20and%20crimson%20flowing%20curves%20in%20a%20dark%20control%20room%2C%20clean%20editorial%20tech%20photography%20with%20depth%20of%20field&width=1200&height=800&seq=rumor-cover-algo-01&orientation=landscape",
    insider: "前算法运营 · 代号「权重」",
    publishedAt: "2026-09-01 22:36",
    heat: 57300,
    tags: ["流量分配", "推荐算法", "创作者"],
    blocks: [
      { type: "p", text: "算法调整通常以实验的形式灰度上线，创作者往往是最晚知道、最早感受到的那一群人。" },
      { type: "p", text: "这次调整涉及对互动深度指标的重新加权。简单说，过去被视为「有效互动」的部分行为，权重被下调，而另一些此前不太重要的信号被抬高了。" },
      { type: "h2", text: "七版说明说明什么" },
      { type: "p", text: "内部沟通材料在定稿前经历了七次修改。知情人士透露，反复修改的部分并不是算法本身，而是对创作者的解释口径——既要说明方向，又不能把规则讲得太具体。" },
      { type: "quote", text: "规则写得越细，被反向优化的空间就越大。这是每一次说明都含糊其辞的根本原因。" },
      { type: "p", text: "目前平台尚未发布面向创作者的正式说明，多个内容团队已经开始自行复盘近期数据的异常波动。" },
    ],
  },
  {
    id: "scenic-area-limit-draft",
    title: "某热门景区限流新规出台前，一份被撤回的内部讨论稿",
    categorySlug: "minsheng",
    categoryName: "城市民生",
    excerpt:
      "新规发布前两天，一份标注「征求意见稿」的文件短暂出现在官网，随后被撤下。再出现时，其中一条关键条款已经被删掉。",
    cover:
      "https://readdy.ai/api/search-image?query=Mountain%20viewpoint%20boardwalk%20at%20sunrise%20with%20warm%20golden%20mist%20and%20a%20crowd%20barrier%20in%20foreground%2C%20editorial%20travel%20photography%20with%20soft%20amber%20light&width=1200&height=800&seq=rumor-cover-scenic-01&orientation=landscape",
    insider: "文旅系统工作人员 · 代号「售票口」",
    publishedAt: "2026-08-31 16:08",
    heat: 42600,
    tags: ["景区限流", "征求意见", "出行"],
    blocks: [
      { type: "p", text: "征求意见稿被撤下并不一定意味着有争议，也可能只是流程问题。但这次的撤下与再发布之间，恰好隔了四十八小时，而条款出现了实质变化。" },
      { type: "p", text: "被删掉的是一条与预约时段挂钩的退改规则。原稿中，临近时段的退票限制较为严格；正式版本里，这一条被整段移除。" },
      { type: "h2", text: "限流背后的两难" },
      { type: "p", text: "景区限流的初衷是安全与体验，但执行时往往会与周边商户、交通接驳和票务系统产生摩擦。规则越严，争议越大；规则越松，旺季秩序越难维持。" },
      { type: "quote", text: "限流数字不是拍脑袋定的，它是有承载量模型的。真正难的是怎么把模型翻译成游客能接受的规则。" },
      { type: "p", text: "新规已于本周正式实施，景区方面表示将根据首个高峰周末的实际运行情况进行评估。" },
    ],
  },
  {
    id: "music-festival-cancel",
    title: "某音乐节临时取消始末：票房、天气与一纸合同的罗生门",
    categorySlug: "zongyi",
    categoryName: "综艺影视",
    excerpt:
      "开演前一周，主办方连续发布了两份口径不同的公告。乐迷关心退票，而行业里更关心的是那份迟迟没有盖章的场地协议。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20scaffolding%20and%20warm%20crimson%20stage%20lights%2C%20moody%20editorial%20photography%20with%20stormy%20sky&width=1200&height=800&seq=rumor-cover-festival-01&orientation=landscape",
    insider: "演出执行公司项目经理 · 代号「返听」",
    publishedAt: "2026-08-29 21:52",
    heat: 48900,
    tags: ["音乐节", "退票", "场地协议"],
    blocks: [
      { type: "p", text: "演出取消的理由通常写得很简短，但每一个取消背后，都有一串按时间排列的节点。" },
      { type: "p", text: "据参与执行的人士回忆，最早的隐患出现在场地使用许可的续签环节。协议草案早已拟定，但双方在保险责任条款上迟迟没有达成一致。" },
      { type: "h2", text: "两份公告之间的沉默" },
      { type: "p", text: "第一份公告提到的是「不可抗力」，第二份则改口为「筹备调整」。口径变化的这段时间内，团队其实仍在尝试推进，直到确认无法在开演前完成全部审批。" },
      { type: "quote", text: "真正致命的从来不是某一个问题，而是几个问题恰好卡在同一周。" },
      { type: "p", text: "主办方表示退票通道将在三个工作日内开启，已购票观众的交通与住宿相关问题将通过客服统一处理。" },
    ],
  },
];

export const getRumorById = (id: string): Rumor | undefined =>
  rumors.find((item) => item.id === id);